module.exports = __webpack_public_path__ + "static/media/codemydrones-logo.8d22b696.png";